import * as yup from 'yup'
import { postcodeValidator } from 'postcode-validator'
import TXT from '@/messages'

const {
  formErrors: {
    email: emailMsg,
    emailConfirm,
    required,
    zip,
    giftEmail,
  },
} = TXT

export const schema = yup.object().shape({
  email: yup.string()
    .trim()
    .email(emailMsg)
    .required(required),
  emailConfirm: yup.string()
    .trim()
    .oneOf([yup.ref('email')], emailConfirm)
    .required(required),
  firstName: yup.string()
    .trim()
    .required(required),
  lastName: yup.string()
    .trim()
    .required(required),
  zipCode: yup.string().trim()
    .when('country', {
      is: (value: string) => value === 'US' || value === 'CA',
      then: (s) => s.test(
        'validPostalCode',
        zip,
        (value, ctx) => postcodeValidator(value || '', ctx.parent.country),
      ),
      otherwise: (s) => s
        .min(4, TXT.formErrors.zipMinLength)
        .max(10, TXT.formErrors.zipMaxLength),
    }),
  country: yup.string().required(required),
  giftOrder: yup.string(),
  giftOrderFirstName: yup.string()
    .when('giftOrder', {
      is: 'true',
      then: (s) => s.trim().required(required),
    }),
  giftOrderLastName: yup.string()
    .when('giftOrder', {
      is: 'true',
      then: (s) => s.trim().required(required),
    }),
  giftOrderEmail: yup.string()
    .when('giftOrder', {
      is: 'true',
      then: (s) => s
        .email(emailMsg)
        .notOneOf([yup.ref('emailConfirm')], giftEmail)
        .required(required),
    }),
  giftOrderMessage: yup.string(),
})
